import React from 'react'
import PriceRowCaption from 'components/Luxkit/PricePoints/PriceRowCaption'
import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'
import PriceRowValueDiscountWithCaption from 'components/Luxkit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import OfferPageStickyFooter from './OfferPageStickyFooter'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import { getHotelOfferDisplayedValue } from 'lib/offer/getOfferDisplayPricing'
import { useOfferPackagePrice } from 'hooks/Offers/useOfferPrice'

interface Props {
  lowestPricePackage: App.Package | App.BundlePackageWithPrice;
  onScrollTo: () => void;
  offer: App.Offer | App.OfferSummary;
  visible: boolean;
}

function HotelOfferPageStickyFooter(props: Props) {
  const {
    onScrollTo,
    offer,
    visible,
  } = props

  const pricePackage = useOfferPackagePrice(props.lowestPricePackage, offer)
  const shouldShowRate = pricePackage.valueOffPercent >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE
  const shouldShowValue = getHotelOfferDisplayedValue(!!offer.bundledWithFlightsOnly, pricePackage.totalPrice, pricePackage.totalValue, !!offer.shouldDisplayValue)

  return (
    <OfferPageStickyFooter visible={visible} callToActionCopy="View options" onCTAClick={onScrollTo}>
      <div>
        <PriceRowCaption>
          {props.lowestPricePackage.durationLabel} from
        </PriceRowCaption>
        <PriceRowPrice
          size="M"
          price={pricePackage.totalPrice}
          saleUnit={pricePackage.saleUnit}
        />
        {shouldShowValue && shouldShowRate && <PriceRowValueDiscountWithCaption
          size="L"
          value={Math.ceil(pricePackage.totalValue)}
          discountPercentage={pricePackage.valueOffPercent}
        />}
      </div>
    </OfferPageStickyFooter>
  )
}

export default HotelOfferPageStickyFooter
